import { Box } from '@zillow/constellation-10';

import { AppSelectors } from '../../../../selectors';
import { useSelector } from '../../../../selectors/useSelector';

import PropertyConstants from '../../../../constants/PropertyConstants';

import ConnectedNetworkView from '../../../../components/ConnectedNetworkView';

const { SYNDICATION_OVERVIEW_STATUS } = PropertyConstants;

const AdditionalInformation = (): JSX.Element | null => {
  const {
    syndication,
    syndication: {
      overview: { status },
    },
  } = useSelector((state) => state.properties.currentProperty);
  const isScreenMobile = useSelector((state) => AppSelectors.makeIsScreenMobile(state));

  if (status === SYNDICATION_OVERVIEW_STATUS.PARTIALLY_PUBLISHED) {
    return (
      <Box css={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}>
        <ConnectedNetworkView syndication={syndication} label={`View published ${isScreenMobile ? '' : 'listings'}`} />
      </Box>
    );
  }

  return null;
};

export default AdditionalInformation;
